module.exports = __webpack_public_path__ + "media/images/lb/423-6f7040ab697f0c1ef77f0d8d6cb63bfe.svg";